import { createReducer, on } from "@ngrx/store";
import { CountriesState } from "./countries.state";
import { CountriesActions } from "./countries.actions";

const initialCountriesState: CountriesState = {
  countries: [],
};

export const CountriesReducer = createReducer<CountriesState>(
  initialCountriesState,
  on(CountriesActions.getCountries, (state): CountriesState => {
    return {
      ...state,
    };
  }),

  on(CountriesActions.setCountries, (state, {countries}):CountriesState => {
    return {
        ...state, 
        countries:countries
    }
  })
);
